// This created to avoid using object key as titles for alert blocks

export const alertNames = {
  urgent: 'Urgent',
  warning: 'Warning',
  general: 'Visit',
};
